<template>
  <li class="col-12 overview-item listed-search-article">
    <div class="card">

      <a class="link card-link" :href="url || '#'" target="_self"  role="navigation">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="card-title">
                <h2 class="card-title-heading">
                  <span class="row">
                    <span class="col-12 col-md-9">
                      {{ (item && item['page_title_s']) || 'Kein Titel' }}
                    </span>
                    <span class="col-12 col-md-3 text-right">
                      <template v-if="badges">
                        <span
                          v-for="(badge, index) in badges" v-bind:key="index"
                          :class="`badge border border-dark text-dark${(parseInt(index) > 0) ? ' ml-1' : ''}`"
                          >
                          {{ badge }}
                        </span>
                      </template>
                    </span>
                  </span>
                </h2>
              </div>
              <p v-if="highlight" v-html="sanitizeHtml(`&hellip;&nbsp;${highlight}&nbsp;&hellip;`)" class="card-text"></p>
            </div>
          </div>
        </div>
      </a>

      <p v-if="ancestors && ancestors.length > 0" class="breadcrumb mb-0 pb-0">
        <template v-for="(ancItem, index) in (ancestors || [])" v-bind:key="index">
          <a :href="sanitizeUrl(ancItem.link || '#')">
            {{ ancItem.title || 'Kein Titel' }}
          </a>
          <span v-if="(index + 1) < ancestors.length"> / </span>
        </template>
      </p>

    </div>
    <div class="badge" aria-hidden="true"></div>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { formatDate } from '../../utils/dateUtils'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { sanitizeHtml } from '@/utils/domUtils'

export default defineComponent({
  name: 'Page',
  props: {
    item: Object,
    highlight: String,
    nodeLink: Object,
    dependants: Object,
    ancestors: Object,
    badges: Object,
  },
  data() {
    return {
      sanitizeUrl: sanitizeUrl,
      sanitizeHtml: sanitizeHtml
    };
  },
  computed: {
    formatDate(): string {
      if (this.item && this.item['comparable_date_dt']) {
        return formatDate(this.item['comparable_date_dt'])
      }
      if (this.item && this.item['last_modified']) {
        return formatDate(this.item['last_modified'])
      }
      return ''
    },
    url(): string {
      if (this.nodeLink && this.nodeLink.link) {
        return sanitizeUrl(this.nodeLink.link)
      } else if (this.item && this.item['url'] && this.item['url'][0]) {
        return sanitizeUrl(this.item.url[0])
      }
      return '#'
    }
  }
});
</script>
<style scoped>
</style>
